import { render, staticRenderFns } from "./main-bar.vue?vue&type=template&id=42e3c45c&"
import script from "./main-bar.vue?vue&type=script&lang=js&"
export * from "./main-bar.vue?vue&type=script&lang=js&"
import style0 from "./main-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e3c45c')) {
      api.createRecord('42e3c45c', component.options)
    } else {
      api.reload('42e3c45c', component.options)
    }
    module.hot.accept("./main-bar.vue?vue&type=template&id=42e3c45c&", function () {
      api.rerender('42e3c45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/header/main-bar.vue"
export default component.exports